/** How many rows from the top still count as "reading the oldest messages". */
export const OLDER_MESSAGES_ROW_THRESHOLD = 50

type ScrollState = {
  /** Index of the first row on screen. */
  startIndex: number
  /** Rows currently in the list. */
  rowCount: number
  /** Row count the last fetch was started for — guards against duplicates. */
  alreadyFetchedCount: number
  /** Distance from the top of the thread, in pixels. */
  scrollOffset: number
  /** Height of the whole thread, in pixels. */
  scrollSize: number
  /** Height of the visible part of the thread, in pixels. */
  viewportSize: number
}

/**
 * Whether scrolling has reached the point of pulling another page of history.
 *
 * The row index alone is not enough. The driver workspace shows only the
 * agent thread in this column, and a column of a few dozen rows is "within
 * fifty rows of the top" everywhere — including at the newest message, where
 * nobody asked for history. Pixels settle it: there has to be something to
 * scroll through, and the dispatcher has to be within a screen of the top.
 */
export const shouldFetchOlderMessages = ({
  startIndex,
  rowCount,
  alreadyFetchedCount,
  scrollOffset,
  scrollSize,
  viewportSize,
}: ScrollState): boolean =>
  alreadyFetchedCount < rowCount &&
  startIndex - OLDER_MESSAGES_ROW_THRESHOLD < 0 &&
  scrollSize > viewportSize &&
  scrollOffset < viewportSize
